module.exports = __webpack_public_path__ + "store/img/buckle_500x500.5e74dea0.svg";